
const state = {
    results: {}
};

export default {
    namespaced: true,
    state,
    getters: {
        getSearchResults: (state) => state.results,
        getTotalResults: (state, getters) => {
            const keysArray = Object.keys(getters.getSearchResults);
            return keysArray.reduce((acumm, key) =>
                acumm + getters.getSearchResults[key].length
                , 0)
        },
        getCardInfoById: (state, getters) => (productId) => {
            for (let searchResultsKey in getters.getSearchResults) {
                for (let itemsBySlugKey in getters.getSearchResults[searchResultsKey]) {
                    if(getters.getSearchResults[searchResultsKey][itemsBySlugKey]['id'] == productId) {
                        return getters.getSearchResults[searchResultsKey][itemsBySlugKey];
                    }
                }
            }

        },
        getCardInfoBySlug: (state, getters) => (slug) =>
            getters.getSearchResults[slug],
        getTotalCardInfoBySlug: (state, getters) => (slug) =>
            getters.getSearchResults[slug].length,
        getTotalAvailabilityBySlug: (state, getters) => (slug) => {
            return getters.getSearchResults[slug]?.reduce((acumm, card) =>
                acumm + card.style_qty?.reduce((availability, style) =>
                    availability + (style?.maxQtyAvailable || 0)
                    , 0)
                , 0)
        }
        ,
    },
    actions: {
        updateResults: ({ commit }, value) =>
            commit('updateResults', value),
    },
    mutations: {
        updateResults: (state, payload) => {
            state.results = payload.reduce((acumm, cardGroup) => ({
                ...acumm,
                [cardGroup[0].clean_slug]: cardGroup
            }), {});
        },
    }
}